import { Link as RouterLink } from "@tanstack/react-router";

// Material-ui imports
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";

export const ContractListHeader = () => {
  let heading = "Contracts";
  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        justifyContent: "space-between",
        alignItems: "center",
        pb: 1,
      }}
    >
      <Typography variant="h5">{heading}</Typography>
      <Stack direction="row" spacing={2}>
        <Button variant="outlined" component={RouterLink} to="/contracts/new">
          New Contract
        </Button>
      </Stack>
    </Stack>
  );
};
